import placeHolder from '~/assets/img/placeholder.jpg';

export function getClientLogo(logoPath: string | null) {
  if (logoPath) {
    const relativePath = logoPath.replace(/https:\/\/(dev|www)\.dianomi\.com/, '');
    return process.env.REACT_APP_ENVIRONMENT !== 'prod' ? `/preview${relativePath}` : relativePath;
  }
  return placeHolder;
}
